

const AttentionIcon = () => (
    <svg width="9" height="59" viewBox="0 0 9 59" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.364 40.78L1.216 0.599996H8.104L6.874 40.78H2.364ZM4.66 58.41C3.45733 58.41 2.41867 58 1.544 57.18C0.724001 56.3053 0.314001 55.294 0.314001 54.146C0.314001 52.9433 0.724001 51.9593 1.544 51.194C2.41867 50.374 3.45733 49.964 4.66 49.964C5.91733 49.964 6.92867 50.374 7.694 51.194C8.514 51.9593 8.924 52.9433 8.924 54.146C8.924 55.294 8.514 56.3053 7.694 57.18C6.92867 58 5.91733 58.41 4.66 58.41Z" fill="#DB0000" />
    </svg>
);

export default AttentionIcon;